import styled from "styled-components";
import NoTextSelectionStyles from "../../../common/styles/no-text-selection";

const EmergencyContactSC = styled.div`
    width: 100%;
    margin-top: 56px;

    .emergency-content {
        text-align: center;
        margin: 0 auto;
        overflow: hidden;
        display: flex;
        border-radius: 10px;
        flex-direction: column;
        justify-content: center;
        background: #e7e4e4;
        width: 85%;
        align-items: center;
        padding: 80px 20px;

        p {
            font-size: 18px;
            width: 80%;
            color: #444343;
            margin-bottom: 30px;
        }

        h2 {
            font-size: 28px;
            font-weight: 600;
            margin-bottom: 12px;
        }
    }

    .contact-number {
        font-size: 24px;
        margin-bottom: 12px;
        color: #444343;
        span {
            font-size: 42px;
            font-weight: 600;
            cursor: pointer;
        }
    }

    .know-more {
        margin-top: 8px;
        font-size: 16px;
        color: #444343;
        cursor: pointer;
    }

    .disable-text { 
        ${NoTextSelectionStyles}
    }

    .number-copied {
        margin-top: 12px;
        font-size: 14px;
        color: #5d5c5cff;
        font-weight: 600;
        opacity: 1;
        border-radius: 10px;
        height: 24px;
        animation: fadeIn 0.5s ease-in-out;
    }

    @keyframes fadeIn {
        from {
            opacity: 0;
        }
        to {
            opacity: 1;
        }
    }

    @media (max-width: 768px) {
        margin-top: 24px;
        display: flex;
        align-items: center;
        justify-content: center;

        .emergency-content {
            margin: 0 auto;
            padding: 14px 22px;
            border-radius: unset;
            width: calc(100% - 32px);

            p {
                font-size: 14px;
                line-height: 1.4;
                letter-spacing: 0.75px;
                width: 80%;
                margin-bottom: 24px;
            }

            h2 {
                font-size: 24px;
                font-weight: 600;
                margin-bottom: 8px;
            }
        }

        .contact-number {
            font-size: 18px;
            margin-bottom: 8px;
            color: #444343;

            span {
                font-size: 36px;
                font-weight: 600;
                cursor: pointer;
            }
        }

        .know-more {
            font-size: 14px;
            -webkit-tap-highlight-color: transparent;
        }

        .number-copied {
            margin-top: 12px;
            font-size: 14px;
            color: #5d5c5cff;
            font-weight: 600;
            opacity: 1;
            border-radius: 10px;
            height: 24px;
            animation: fadeIn 0.5s ease-in-out;
        }
    }
`;

export default EmergencyContactSC;
